import { createContext, useContext } from 'react'

const SidebarCollapsedContext = createContext(false)

export const SidebarCollapsedProvider = SidebarCollapsedContext.Provider
export const useSidebarCollapsed = () => useContext(SidebarCollapsedContext)
